import { useRef } from 'react';
import { useController, useFormContext } from 'react-hook-form';

import { FormattedNumberInput } from '@flipster/react/design-utils/formatted-input';
import { css, cx } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';
import { inputFormatter } from '@flipster/utils/num';

interface Props {
  name: string;
  currency: string;
  currencyClassName?: string;
  precision: number;
  max?: string;
  placeholder?: string;
}

const SendPriceInput = ({ name, precision, currency, max, placeholder = '0', currencyClassName }: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { control, trigger } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const handleChange = (newValue: string) => {
    onChange(newValue);
    trigger(name);
  };

  return (
    <div
      className={css({ position: 'relative', width: '100%' })}
      onClick={() => {
        inputRef.current?.focus();
      }}
    >
      <div className={center({ width: '100%', zIndex: 1 })}>
        <FormattedNumberInput
          ref={inputRef}
          value={value}
          onChange={handleChange}
          precision={precision}
          className={css({
            width: '100%',
            zIndex: 1,
            textStyle: 'Title/M',
            color: 'transparent',
            textAlign: 'center',
            caretColor: 'content.accent.info',
          })}
          max={max}
          onBlur={() => {
            trigger(name);
          }}
        />
        <span
          className={cx(
            css({
              textStyle: 'Title/M',
              color: 'transparent',
              marginLeft: 16,
            }),
            currencyClassName,
          )}
        >
          {currency}
        </span>
      </div>
      <div
        className={css({
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          textStyle: 'Title/M',
          color: Number(value) > 0 ? 'inverse.white' : 'content.default.level-1',
        })}
      >
        <span>
          {(!value || value === '0') && placeholder ? placeholder : inputFormatter(value, { withComma: true })}
        </span>
        <span className={currencyClassName}>{currency}</span>
      </div>
    </div>
  );
};

export default SendPriceInput;
